"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebB = void 0;
// import { version } from "../package.json";
var constants_1 = require("./constants");
var requestManager_1 = __importDefault(require("./requestManager"));
/**
 * The main webB class
 */
var WebB = /** @class */ (function () {
    function WebB() {
        // version = version;
        var _this = this;
        this.requestManager = requestManager_1.default;
        this.getPermission = function () {
            return new Promise(function (resolve, reject) {
                _this.requestManager.newMessage({
                    command: constants_1.COMMANDS.GET_PERMISSION,
                    resolve: resolve,
                    reject: reject,
                });
            });
        };
        this.getAddress = function (coin) {
            return new Promise(function (resolve, reject) {
                return _this.requestManager.newMessage({
                    command: constants_1.COMMANDS.GET_ADDRESS,
                    data: { coin: coin },
                    resolve: resolve,
                    reject: reject,
                });
            });
        };
        this.getInfo = function () {
            return new Promise(function (resolve, reject) {
                return _this.requestManager.newMessage({
                    command: constants_1.COMMANDS.GET_INFO,
                    reject: reject,
                    resolve: resolve,
                });
            });
        };
    }
    return WebB;
}());
exports.WebB = WebB;
//# sourceMappingURL=WebB.js.map